export default {"src":"/_next/static/media/twitter.36da0d4e.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};